import { render, staticRenderFns } from "./GridContacto.vue?vue&type=template&id=981c795e&"
import script from "./GridContacto.vue?vue&type=script&lang=js&"
export * from "./GridContacto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports